"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const every_1 = __importDefault(require("lodash/every"));
const filter_1 = __importDefault(require("lodash/filter"));
const forEach_1 = __importDefault(require("lodash/forEach"));
const get_1 = __importDefault(require("lodash/get"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const keys_1 = __importDefault(require("lodash/keys"));
const map_1 = __importDefault(require("lodash/map"));
const mapKeys_1 = __importDefault(require("lodash/mapKeys"));
const pickBy_1 = __importDefault(require("lodash/pickBy"));
const some_1 = __importDefault(require("lodash/some"));
const startCase_1 = __importDefault(require("lodash/startCase"));
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
const mobx_1 = require("mobx");
const FILTER_KEYS_1 = __importDefault(require("../constants/app/FILTER_KEYS"));
const mapInitialStateToStoreState_1 = __importDefault(require("../utils/store/mapInitialStateToStoreState"));
/**
 * Fleet Filter Domain Store
 * Stores filter state for listing page filters
 */
class FleetFilterStore {
    constructor(initialState) {
        this.filterState = {};
        this.appliedFilterState = {};
        /**
         * Method that returns the filter criteria for a category
         * @param {Object} categoryFilterState
         * @returns {Array}
         */
        this.createFilterCriteria = (categoryFilterState) => {
            const selectedFilterState = (0, pickBy_1.default)(categoryFilterState, (value) => {
                return value;
            });
            const mappedSelectedFilterState = (0, mapKeys_1.default)(selectedFilterState, (value, key) => {
                return key.toLowerCase().trim();
            });
            return (0, keys_1.default)(mappedSelectedFilterState);
        };
        /**
         * Construct the filter state from fleet data
         * @param {Array} fleetArr
         */
        this.initializeFilterState = (fleetArr) => {
            // construct the filter state from the fleet group info
            // we are using filter keys to extract data
            const filterStateObj = {};
            (0, forEach_1.default)(FILTER_KEYS_1.default, (filterKey) => {
                // removes duplicates and returns only the filter value for the key
                const allData = (0, map_1.default)((0, uniqBy_1.default)(fleetArr, filterKey), (fleet) => {
                    return fleet[filterKey];
                });
                // removes empty strings
                const filteredData = (0, filter_1.default)(allData, (fleet) => {
                    return !!fleet;
                });
                // construct individual filter object mapping
                const filterObj = {};
                (0, forEach_1.default)(filteredData, (filterName) => {
                    filterObj[(0, startCase_1.default)(filterName.trim().toLowerCase())] = false;
                });
                // prepare the filter state for each filter key
                filterStateObj[filterKey] = filterObj;
            });
            // mutate filter state observable
            this.filterState = filterStateObj;
            this.applyFilters();
        };
        /**
         * Update filter state
         * @param {string} name
         * @param {boolean} value
         * @param {string} filterType
         */
        this.updateFilterState = (name, value, filterType) => {
            // mutate filter state observable
            this.filterState = Object.assign(Object.assign({}, this.filterState), { [filterType]: Object.assign(Object.assign({}, this.filterState[filterType]), { [name]: value }) });
        };
        /**  start-no-seo */
        /**
         * Resets a passed filter category
         * @param {string} filterKey
         */
        this.resetFilter = (filterKey) => {
            const categoryFilterState = (0, get_1.default)(this.filterState, filterKey, {});
            (0, forEach_1.default)(categoryFilterState, (value, key) => {
                categoryFilterState[key] = false;
            });
            // mutate filter state observable
            this.filterState = Object.assign(Object.assign({}, this.filterState), { [filterKey]: categoryFilterState });
        };
        /** end-no-seo */
        /**
         * Action to be called when click on Apply filters
         */
        this.applyFilters = () => {
            this.appliedFilterState = Object.assign({}, this.filterState);
        };
        /**  start-no-seo */
        /**
         * Action to be called when click on Apply filters
         */
        this.applySelectedFilters = (selectedFilters) => {
            this.filterState = Object.assign(Object.assign({}, this.filterState), selectedFilters);
        };
        /**
         * Discard current filter changes
         */
        this.discardFilters = () => {
            this.filterState = Object.assign({}, this.appliedFilterState);
        };
        /** end-no-seo */
        /**
         * Resets all filter
         */
        this.resetAllFilters = () => {
            const resetAllFilterState = Object.assign({}, this.filterState);
            (0, forEach_1.default)(FILTER_KEYS_1.default, (filterKey) => {
                const categoryFilterState = (0, get_1.default)(resetAllFilterState, filterKey, {});
                (0, forEach_1.default)(categoryFilterState, (value, key) => {
                    categoryFilterState[key] = false;
                });
                resetAllFilterState[filterKey] = categoryFilterState;
            });
            // mutate filter state observable
            this.filterState = resetAllFilterState;
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.updateInitialState(initialState);
    }
    /**  start-no-seo */
    /**
     * Returns true if filters has changed from last applied state
     * Used for close button
     */
    get hasFiltersChanged() {
        return !(0, isEqual_1.default)(this.appliedFilterState, this.filterState);
    }
    /**
     * Returns true if filter state was generated
     */
    get hasFilters() {
        return !((0, isEmpty_1.default)(this.filterState) ||
            (0, every_1.default)(this.filterState, (value) => {
                return (0, isEmpty_1.default)(value);
            }));
    }
    /** end-no-seo */
    /**
     * Returns true if no filter is selected
     * @returns {boolean}
     */
    get isNoFiltersSelected() {
        return !(this.isMakeFilterSelected ||
            this.isClassFilterSelected ||
            this.isTransmissionFilterSelected);
    }
    /**
     * Returns true if any make/brand filter is selected
     * @returns {boolean}
     */
    get isMakeFilterSelected() {
        const makeFilterState = (0, get_1.default)(this.filterState, 'make', {});
        return (0, some_1.default)(makeFilterState, (value) => {
            return value;
        });
    }
    /**
     * Returns true if any class/type filter is selected
     * @returns {boolean}
     */
    get isClassFilterSelected() {
        const classFilterState = (0, get_1.default)(this.filterState, 'class', {});
        return (0, some_1.default)(classFilterState, (value) => {
            return value;
        });
    }
    /**
     * Returns true if any transmission filter is selected
     * @returns {boolean}
     */
    get isTransmissionFilterSelected() {
        const transmissionFilterState = (0, get_1.default)(this.filterState, 'transmission', {});
        return (0, some_1.default)(transmissionFilterState, (value) => {
            return value;
        });
    }
    /**
     * Returns true if reset all is enabled
     * @returns {boolean}
     */
    get resetAllEnabled() {
        return !this.isNoFiltersSelected;
    }
    /**  start-no-seo */
    /**
     * Returns true if reset make is enabled
     * @returns {boolean}
     */
    get resetMakeEnabled() {
        return this.isMakeFilterSelected;
    }
    /** end-no-seo */
    /**
     * Returns only the filters that are true in the following format
     * @return {Object}
     * eg. {
     *       make: ["toyota", "mercedes benz"],
     *       class: ["suv"]
     *     }
     */
    get filterCriteria() {
        const filterCriteria = {};
        (0, forEach_1.default)(FILTER_KEYS_1.default, (filterKey) => {
            const categoryFilterState = (0, get_1.default)(this.filterState, filterKey, {});
            const categoryFilterCriteria = this.createFilterCriteria(categoryFilterState);
            filterCriteria[filterKey] = categoryFilterCriteria;
        });
        return filterCriteria;
    }
}
__decorate([
    mobx_1.observable
], FleetFilterStore.prototype, "filterState", void 0);
__decorate([
    mobx_1.observable
], FleetFilterStore.prototype, "appliedFilterState", void 0);
__decorate([
    mobx_1.computed
], FleetFilterStore.prototype, "hasFiltersChanged", null);
__decorate([
    mobx_1.computed
], FleetFilterStore.prototype, "hasFilters", null);
__decorate([
    mobx_1.computed
], FleetFilterStore.prototype, "isNoFiltersSelected", null);
__decorate([
    mobx_1.computed
], FleetFilterStore.prototype, "isMakeFilterSelected", null);
__decorate([
    mobx_1.computed
], FleetFilterStore.prototype, "isClassFilterSelected", null);
__decorate([
    mobx_1.computed
], FleetFilterStore.prototype, "isTransmissionFilterSelected", null);
__decorate([
    mobx_1.computed
], FleetFilterStore.prototype, "resetAllEnabled", null);
__decorate([
    mobx_1.computed
], FleetFilterStore.prototype, "resetMakeEnabled", null);
__decorate([
    mobx_1.computed
], FleetFilterStore.prototype, "filterCriteria", null);
__decorate([
    mobx_1.action.bound
], FleetFilterStore.prototype, "initializeFilterState", void 0);
__decorate([
    mobx_1.action.bound
], FleetFilterStore.prototype, "updateFilterState", void 0);
__decorate([
    mobx_1.action.bound
], FleetFilterStore.prototype, "resetFilter", void 0);
__decorate([
    mobx_1.action.bound
], FleetFilterStore.prototype, "applyFilters", void 0);
__decorate([
    mobx_1.action.bound
], FleetFilterStore.prototype, "applySelectedFilters", void 0);
__decorate([
    mobx_1.action.bound
], FleetFilterStore.prototype, "discardFilters", void 0);
__decorate([
    mobx_1.action.bound
], FleetFilterStore.prototype, "resetAllFilters", void 0);
__decorate([
    mobx_1.action.bound
], FleetFilterStore.prototype, "updateInitialState", void 0);
exports.default = FleetFilterStore;
